import React, { useState } from "react";
import { ShieldCheck, CreditCard, Users, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "jt_teacher_tour_done";
const STEPS = [
  { icon: ShieldCheck, t: "1. Verify your school email", d: "Enter the 6-digit code we email to your school address. This unlocks classroom licences." },
  { icon: CreditCard, t: "2. Buy a classroom licence — £400", d: "Create a class, open its Licences tab and unlock a full course for every student in it." },
  { icon: Users, t: "3. Add your students", d: "Share the class join code or invite link. Students appear in your roster as soon as they join." },
];

export const TeacherTour = () => {
  const [step, setStep] = useState(() => (localStorage.getItem(KEY) ? -1 : 0));
  if (step < 0) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setStep(-1); };
  const s = STEPS[step];
  const last = step === STEPS.length - 1;

  return (
    <div className="mt-8 rounded-2xl border border-primary/40 bg-primary/10 p-5" data-testid="teacher-tour">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <s.icon size={20} className="mt-0.5 text-primary" />
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-primary">Welcome tour · step {step + 1} of {STEPS.length}</p>
            <p className="mt-1 font-serif text-lg" data-testid="teacher-tour-title">{s.t}</p>
            <p className="mt-1 text-sm text-muted-foreground">{s.d}</p>
          </div>
        </div>
        <button onClick={close} data-testid="teacher-tour-close" className="rounded-full p-1 text-muted-foreground hover:text-foreground"><X size={16} /></button>
      </div>
      <div className="mt-4 flex items-center gap-2">
        {step > 0 && (
          <Button variant="outline" onClick={() => setStep(step - 1)} data-testid="teacher-tour-prev" className="rounded-full">Back</Button>
        )}
        <Button onClick={() => (last ? close() : setStep(step + 1))} data-testid="teacher-tour-next" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90">
          {last ? "Got it" : "Next"}
        </Button>
      </div>
    </div>
  );
};
